<template>
  <div>
    <Header ref="gituser"></Header>
    <div class="back_content" @click="bank"><img src="../assets/shape(1).svg" alt=""> {{$t('pay_Success.Go_Home')}}</div>
    <div class="stoi_sinmin mtin">{{$t('pay_Success.Payment')}}</div>
    <div class="stoi_sinmin">{{$t('pay_Success.We')}}</div>
    <div class="fonth_km mgin_tuna">{{$t('pay_Success.You')}}</div>
    <div class="fonth_km">{{$t('pay_Success.Below')}}</div>


    <div class="yuan_dsimqwq">
      <div class="contenserm">
        <img class="txqq" src="../assets/Ellipse395.svg" alt="">

        <div class="maimaa">{{user_info.name}}</div>
        <div class="inntxta">({{user_info.describe}})</div>

        <div class="sin_boimn">
          <img class="immkkll" src="../assets/Message.svg" alt="">
          <div class="ziticol">{{user_info.email}}</div>
        </div>
        <div class="sin_boimn">
          <img class="immkkll" src="../assets/Stroke1.svg" alt="">
          <div class="ziticol">{{user_info.mobile}}</div>
        </div>
        <div class="sin_boimn">
          <img class="immkkll wx" src="../assets/WeChat_lgo_icon1.svg" alt="">
          <div class="ziticol" style="margin-left:24px;"><span class="zitimm">{{$t('new_test4.Wechat_ID')}}:</span> {{user_info.wechat}}</div>
        </div>
        <img class="ewm_img" :src="user_info.qr_code" alt="">
      </div>
      <img class="sin_der_tun" src="../assets/Rectangle2668.svg" alt="">
    </div>



  </div>
</template>

<script>
import { setStore, getStore, keys } from '@/store';
import IndexHeader from './views/header'
import IndexFooter from './views/footer'
import store from '@/store/store'
import Header from './header/header'
export default {
  components: {
    IndexHeader,
    IndexFooter,
    Header
  },
  data () {
    return {
      payData: [],
      user_info:[]
    }
  },
  created () {
    if (getStore(keys.token)) {
      if (getStore(keys.userInfo).status == 0) {
        this.$router.push({
          path: '/sinadd'
        })
      }
    } else {
      this.$router.push({
        path: '/'
      })
    }
    this.payData = store.getPayData()
    this.Sales_information();
    this.Refresh();
  },
  methods: {
    bank () {
      this.$router.push({ path: '/home/children/AttendClassNow' })
    },
        /**
     * 获取销售信息
     */
    Sales_information:function(){
      // console.log('测试：',navigator.language)
      let _lan = (navigator.language == 'zh-CN')?'zh_CN': 'en'
      this.$http.get('/api/getUserInfo', {headers: {lan: _lan,token:getStore(keys.token)}}).then((res) => {
        if (res.data.code == 200) {
          setStore(keys.user, res.data.data)
          this.user_info = res.data.data.salesperson_info
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch((error) => {
        console.log(error) // 请求失败返回的数据
      })
    },
    /**
     * 支付成功刷新余额
     */
    Refresh(){
      this.$refs.gituser.get_user();
    }


  }
}
</script>

<style lang="less" scoped>
.contenserm{
  width: 441px;
  // height: 508px; 
  background: #FFFFFF;
  border: 0.666332px solid #F2F2F2;
  box-sizing: border-box;
  box-shadow: 0px 6.66332px 26.6533px rgba(0, 0, 0, 0.08);
  border-radius: 18.6573px;
  margin: -25px 62px 0 12px;
}
.simkeropl{
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: bold;
    font-size: 33px;
    color: #000000;
    text-align: center;

}
.text_jianjie{
    width: 400px;
    font-family: Poppins;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 20px;
    color: #0B1D33;
    text-align: center;
    margin: 20px auto 0 auto;
}
.zk{
    width: 549px;
    height: 551px;
    background: #FFFFFF;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    margin: 30px auto 30px auto;
}
.Scroll_content{
    border:0px solid red;
}
.txqq{
    width: 85px;
    height:85px;
    margin: 50px auto 0 auto;
    display: block;
}
.maimaa{
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 22px;
  line-height: 20px;
  color: #0B1D33;
  text-align: center;
  margin-top:8px;
}
.inntxta{
  // font-family: Poppins;
  font-style: normal;
  // font-weight: 600;
  font-size: 14px;
  text-align: center;
  color: #0B1D33;
  text-align: center;
  margin-top:8px;
    margin-bottom:30px;
}
.sin_boimn{
    width: 335px;
    /* height: 40px; */
    border: 0px solid red;
    margin: 0 auto 32px auto;
    overflow: hidden;
}
.immkkll{
    width: 21.22px;
    height: 19.1px;
    float: left;
    margin-top: 5px;
}
.ziticol{
    font-family: Poppins;
    font-style: normal;
    font-weight: 600;
    font-size: 20px;
    color: #0B1D33;
    margin-left: 31.78px;
    float: left;
}
.wx{
  width: 29.86px !important;
  height: 25px !important;
}
.zitimm{
  font-family: Poppins !important;
  font-style: normal !important;
  font-weight: normal !important;
  font-size: 16px !important;
  line-height: 20px !important;
  color: #0B1D33 !important;
}
.ewm_img{
    width: 106px;
    height: 106px;
    margin: 0 auto 20px auto;
    display: block;
    border:5px solid #4B69FE;
    border-radius: 10px;
}
.stoi_sinmin{
  font-family: Poppins;
  font-style: normal;
  font-weight: 600;
  font-size: 38px;
  line-height: 57px;
  text-align: center;
  color: #0B1D33;
  text-align: center;
}
.mtin{
  margin-top:30px;
}
.fonth_km{
  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 26px;
  /* or 162% */
  text-align: center;
  color: rgba(11, 29, 51, 0.6);
}
.mgin_tuna{
  margin-top:20px;
}
.yuan_dsimqwq{
  width: 557px;
  height: 557px;
  left: 407px;
  top: 341px;
  background: #F2F9FF;
  border: 46.6311px solid #F2F9FF;
  box-sizing: border-box;
  border-radius: 666.159px;
  margin: 15px auto 0 auto;
}
.sin_der_tun{
  position: relative;
    top: -271px;
    right: -496px;
    display: block;
}
.back_content{
  width:1000px;
  margin:20px auto 20px auto;
    font-family: Sofia Pro;
    font-style: normal;
    font-weight: 600;
    font-size: 18px;
    line-height: 18px;
    /* identical to box height, or 100% */
    text-align: left;
    color: #4B69FE;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/paySuccess.vue